import Dexie from 'dexie';

export const db = new Dexie('myDatabase');
db.version(1).stores({
    // report_db: 'info, institutions, others_photo, share', // Primary key and indexed props
    report_db: '++id, info, institutions, others_photo, share'

});